<template>
  <div id="loginSidebar" class="login-left">
      <div class="login-logo">
        <img class="white-logo" src="../assets/images/ametros-learning-logo.svg" alt="logo">
      </div>
      <div class="login-info">
        <p>Building competency and confidence through online <strong>experiential learning.</strong></p>
      </div>
    </div>
</template>
<script>

export default {
  name: "loginSidebar",
  data() {
    return {
      url: process.env.VUE_APP_URL
    };
  },
  methods: {

  }
};
</script>

<style>
.white-logo {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(180deg) brightness(1000%) contrast(100%);
}

</style>

